// extracted by mini-css-extract-plugin
module.exports = {"deck-legend":"LocalizedShipDeckPlansSlider_deck-legend__UI0hF","deckLegend":"LocalizedShipDeckPlansSlider_deck-legend__UI0hF"};